"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const url_1 = require("../../../share/url");
/**
 * __DYNAMIC_CDN_TARGET__, __DYNAMIC_CDN_PROP_POINTER__, __DYNAMIC_CDN_PROP_NAME__
 * 均为编译时动态注入，所以请勿引入
 * PUBLIC_PATH 则是固定
 */
__webpack_public_path__ = `${(0, url_1.trimUrlPathEnd)(((_a = __DYNAMIC_CDN_TARGET__ === null || __DYNAMIC_CDN_TARGET__ === void 0 ? void 0 : __DYNAMIC_CDN_TARGET__[__DYNAMIC_CDN_PROP_POINTER__]) === null || _a === void 0 ? void 0 : _a[__DYNAMIC_CDN_PROP_NAME__]) || '')}/`;
//# sourceMappingURL=public-path.js.map